import { Component, OnInit } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { SdkService } from "src/app/sdk.service";
import Swal from "sweetalert2";
import { ajax } from "jquery";

@Component({
  selector: "app-face-capture",
  templateUrl: "./face-capture.component.html",
  styleUrls: ["./face-capture.component.scss"],
})
export class FaceCaptureComponent implements OnInit {
  isLoading = true;
  face_capture: string;
  clearedFace: string;

  base64Image: any;
  base64String: any;
  backgroundContinuity: any;
  checkIcao: boolean;

  constructor(
    private sdkService: SdkService,
    private _sanitizer: DomSanitizer,
    private readonly route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    this.captureFace();
    this.route.queryParams.subscribe(params => {
      this.backgroundContinuity = params["backgroundContinuity"] ? params["backgroundContinuity"] : 50;
      this.checkIcao = params["checkIcao"] ? params["checkIcao"] : false;
    });
  }

  transform() {
    return this._sanitizer.bypassSecurityTrustResourceUrl(this.base64Image);
  }

  refreshCapture() {
    window.location.reload();
  }

  showErrorMessage(message: string) {
    Swal.fire({
      title: "Detection Failed!",
      text: message,
      // text: "Keep a straight face and remove any object from face.",
      icon: "error",
      confirmButtonColor: "#3085D6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Try Again",
    }).then((isConfirm) => {
      if (isConfirm.isConfirmed) {
        this.captureFace();
      }
    });
  }

  captureFace() {
  this.sdkService
    .capture_face()
    .then((res) => {
      const quality = res.data?.quality || {};
      const icao = res.icao_data || {};

      // Validation checks
      if (quality.eyes_open_metric < 15) {
        this.showErrorMessage('Face elements (eyes) not fully visible.');
        return;
      }
      if (icao.background_continuity < 50) {
        this.showErrorMessage('Background not clear.');
        return;
      }
      if (icao.multiple_faces) {
        this.showErrorMessage('Multiple faces detected.');
        return;
      }
      if (icao.eyeR_visibility < 20 || icao.eyeL_visibility < 20 || icao.mouth_visibility < 20) {
        this.showErrorMessage('Face elements not fully visible.');
        return;
      }
      if (icao.illumination_uniformity < 50) {
        this.showErrorMessage('Face lighting is uneven.');
        return;
      }

      // If ICAO check is disabled, send image directly
      if (this.checkIcao === false) {
        window.parent.postMessage(
          {
            image: icao.templates.PNG,
            status: 200,
            message: "Capture successful!",
          },
          "*"
        );
        return;
      }

      console.log("This is the face capture response ==>>", res.data);
      this.face_capture = icao.templates.PNG;
      this.base64Image = `data:image/png;base64,${icao.templates.PNG}`;

      // Create image element to check brightness
      const img = new Image();
      img.src = this.base64Image;

      img.onload = () => {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;

        let totalBrightness = 0;
        const pixelCount = data.length / 4;

        for (let i = 0; i < data.length; i += 4) {
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];
          const brightness = 0.299 * r + 0.587 * g + 0.114 * b;
          totalBrightness += brightness;
        }

        const averageBrightness = totalBrightness / pixelCount;

        if (averageBrightness < 120) {
          this.showErrorMessage('Image is too dark. Please improve lighting.');
          return;
        }

        if (averageBrightness < 140) {
          const brightenAmount = 140 - averageBrightness + 10;
          for (let i = 0; i < data.length; i += 4) {
            data[i] = Math.min(255, data[i] + brightenAmount);     // R
            data[i + 1] = Math.min(255, data[i + 1] + brightenAmount); // G
            data[i + 2] = Math.min(255, data[i + 2] + brightenAmount); // B
          }
          ctx.putImageData(imageData, 0, 0);
        }

        // Convert to new base64 string
        const updatedBase64 = canvas.toDataURL('image/png').split(',')[1];

        this.sdkService.checkHead(updatedBase64)
          .then((response: any) => {
            console.log("Head Fully Visible:", response.head_fully_visible);
            console.log("Message:", response.message);

            if (response.head_fully_visible === true) {
              window.parent.postMessage(
                {
                  image: updatedBase64,
                  status: 200,
                  message: "Capture successful!",
                },
                "*"
              );
            } else {
              this.showErrorMessage(response.message);
            }
          })
          .catch((error) => {
            console.error("Error:", error);
            this.showErrorMessage('Oops, something went wrong. Please try again');
          });
      };
    })
    .catch((err) => {
      Swal.fire({
        title: "Liveliness Failed!",
        icon: "error",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Try Again",
      }).then((isConfirm) => {
        if (isConfirm.isConfirmed) {
          this.captureFace();
        }
      });
    });
}




}

